"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=fin-package-item.dto.js.map